import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ICampusCompetition } from '@/src/types/resumeDetail/campusType';
import './index.scss';

interface IProps {
  data: ICampusCompetition[];
  setMode: Function;
}

// 仅校招
const CompetitionView: FC<IProps> = (props) => {
  const { data, setMode } = props;

  const { campusResumeFormRefStore } = useRootStore();

  const storeRef = campusResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('competition_edit');
  };

  return (
    <div className="competition_view model_view">
      <div className="model_title">
        <div>竞赛</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_main">
        {data?.map((item) => (
          <div className="model_list" key={item.renderId}>
            <div className="competition_name">
              <span>
                {item.competitionName}({item.awardName})
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompetitionView;
